<h1 mat-dialog-title>Airtime Connections - Device {{ data.deviceId }} - {{ data.reportLabel }}</h1>

<button class="btn-close-icon" mat-icon-button mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
<mat-dialog-content>
  <vectronic-details-item header="Payment Account" [isSmall]="true">
    {{ data.paymentAccountLabel }}
  </vectronic-details-item>
  @if (data.inclusiveBytes !== undefined) {
    <vectronic-details-item header="Bytes (inclusive Bytes)" [isSmall]="true">
      {{ data.bytes }} ({{ data.inclusiveBytes }})
    </vectronic-details-item>
  } @else {
    <vectronic-details-item header="Bytes" [isSmall]="true">
      {{ data.bytes }}
    </vectronic-details-item>
  }
  <vectronic-details-item header="Total Data Fee" [isSmall]="true">
    {{ data.totalDataFee }} {{ data.currency }}
  </vectronic-details-item>

  <div class="connections-table-container">
    <table-datatable [datatableConfig]="datatableConfig" [data]="data.connections">
    </table-datatable>
  </div>
</mat-dialog-content>
